import React from 'react';
import { Modal, Switch, Slider, Row, Col, Divider } from 'antd';
import { PROTOCOLS } from '../../utils/multiWindowLive';

/**
 * 多窗口直播设置弹窗
 */
export default function MultiWindowSettingsModal({
  open,
  onClose,
  autoRefresh,
  setAutoRefresh,
  refreshInterval,
  setRefreshInterval
}) {
  return (
    <Modal
      title="多窗口直播设置"
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <div className="settings-content">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <div className="setting-item">
              <label>自动刷新:</label>
              <Switch
                checked={autoRefresh}
                onChange={setAutoRefresh}
              />
            </div>
          </Col>

          <Col span={12}>
            <div className="setting-item">
              <label>刷新间隔: {refreshInterval}秒</label>
              <Slider
                min={10}
                max={60}
                value={refreshInterval}
                onChange={setRefreshInterval}
                disabled={!autoRefresh}
              />
            </div>
          </Col>
        </Row>

        <Divider />

        <div className="protocol-info">
          <h4>协议说明:</h4>
          <div className="protocol-list">
            {Object.entries(PROTOCOLS).map(([key, config]) => (
              <div key={key} className="protocol-item">
                <span className="protocol-name" style={{ color: config.color }}>
                  {config.name}
                </span>
                <span className="protocol-latency">
                  延迟: {config.latency}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
